import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { createAgent, editAgent, fetchAgentDetail } from '../../actions/agents_actions';


import AgentForm from '../../components/Agents/agentForm';

const validate = values => {
    const errors = {}
    if (!values.Name) {
        errors.Name = 'Required'
    }
    if (!values.AgentNum) {
        errors.AgentNum = 'Required'
    }
    if (!values.Description) {
        errors.Description = 'Required'
    }
    return errors
}

let agentForm = reduxForm({
    form: 'agentForm',
    validate
})(AgentForm);

const selector = formValueSelector('agentForm')

function mapStateToProps(state) {
    return {
        currentAgent: state.agents.currentAgent,
        currentAgentDetail: state.agents.currentAgentDetail,
        detailIsLoading: state.agents.detailIsLoading,
        detailError: state.agents.detailError,
        initialValues: state.agents.currentAgentDetail,
        paymentTerms: state.paymentTerms.all,
        paymentTermsIsLoading: state.paymentTerms.isLoading,
        paymentTermsError: state.paymentTerms.error,
        isCreating: state.agents.isCreating,
        createError: state.agents.createError,
        created: state.agents.created,
        isEditing: state.agents.isEditing,
        editError: state.agents.editError,
        edited: state.agents.edited,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { fetchPaymentTerms, createAgent, editAgent, fetchAgentDetail })(agentForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Agents/agentForm.jsx